// extracted by mini-css-extract-plugin
export default {"searchPanel":"search-panel_searchPanel__nPKd7","staydate":"search-panel_staydate__0Zc52","seperater":"search-panel_seperater__TpdAU"};